import styled from '@emotion/styled'
import React from 'react'
import { PRIMARY_PAGE_FILL_COLOR_VAR } from '../../context/CustomizationContextProvider'
import { ScrollingLayout } from '../../style/scrollingLayout'
import { CartIcon } from './CartIcon'

const Wrapper = styled.div<{ isVisible: boolean }>(({ isVisible }) => ({
    position: 'fixed',
    top: 10,
    right: 15,
    zIndex: 3,
    borderRadius: '50%',
    backgroundColor: `var(${PRIMARY_PAGE_FILL_COLOR_VAR})`,
    boxShadow: isVisible
        ? '0 2px 8px rgba(0, 0, 0, 0.15)'
        : '0 2px 8px rgba(0, 0, 0, 0)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    transition:
        'opacity 250ms ease-out, box-shadow 250ms ease-out, transform 250ms ease-out',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'scale(1)' : 'scale(0.8)',
    pointerEvents: isVisible ? 'auto' : 'none',
    // The header this stands in for stays pinned on desktop, so there is
    // nothing for a floating cart to replace.
    [ScrollingLayout.DESKTOP_MEDIA]: {
        display: 'none',
    },
}))

export const FloatingCart: React.FC<{ isVisible: boolean }> = ({
    isVisible,
}) => (
    <Wrapper isVisible={isVisible}>
        <CartIcon />
    </Wrapper>
)
